import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import styles from './CardButton.module.scss';

const CardButton = ({
  text,
  icon,
  iconPosition = 'left',
  className,
  ...props
}) => {
  return (
    <Button {...props} className={cn(styles.root, className)}>
      {icon && iconPosition === 'left' && <Icon component={() => icon} />}
      {text}
      {icon && iconPosition === 'right' && <Icon component={() => icon} />}
    </Button>
  );
};

export default CardButton;
